import React, { FC, useEffect, useState } from "react";
import { EntryListItem, FilterType } from "./types";
import "./index.scss";
import Dropdown from "../../static/Dropdown/Dropdown";
import { omitNation } from "../../helpers";
import { dropdownItem } from "../../static/Dropdown/types";
import { getEntryList } from "../../services/tournaments";

interface Props {
  qualificationPageId: number;
  playerTypeFilters: string[];
}

const filtersList: FilterType = {
  playerTypeCode: [
    {
      label: "All",
      value: ""
    },
    {
      label: "Women's",
      value: "W"
    },
    {
      label: "Men's",
      value: "M"
    },
    {
      label: "Quad",
      value: "Q"
    }
  ],
  matchTypeCode: [
    {
      label: "Singles",
      value: "S"
    },
    {
      label: "Doubles",
      value: "D"
    }
  ]
};

const EntryList: FC<Props> = ({ qualificationPageId, playerTypeFilters }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [list, setList] = useState<EntryListItem[]>([]);
  const [filters, setFilters] = useState<
    Record<keyof FilterType, dropdownItem>
  >({
    playerTypeCode: filtersList.playerTypeCode[0],
    matchTypeCode: filtersList.matchTypeCode[0]
  });
  const isEmpty = list.filter(({ players }) => players.length).length === 0;
  useEffect(() => {
    if (location.pathname.indexOf("paralympic") === -1) {
      filtersList.matchTypeCode.push({
        label: "Mixed",
        value: "MX"
      });
    }
    document
      .getElementsByTagName("html")[0]
      .classList.add("print-version-entry-list");
    return () => {
      document
        .getElementsByTagName("html")[0]
        .classList.remove("print-version-entry-list");
    };
  }, []);
  filtersList.playerTypeCode = filtersList.playerTypeCode.filter(({ value }) =>
    ["", ...playerTypeFilters].includes(value.toString())
  );
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { playerTypeCode, matchTypeCode } = filters;
        const data: EntryListItem[] = await getEntryList({
          contentId: qualificationPageId,
          playerTypeCode: playerTypeCode.value,
          matchTypeCode: matchTypeCode.value
        });
        setList(data);
      } finally {
        setLoading(false);
      }
    })();
  }, [filters]);
  return (
    <div className="entry-list">
      <div className="entry-list__print-title">
        <span>
          Paris 2024 Olympic Tennis Event Entry List /{" "}
          {Object.values(filters)
            .map(({ label }) => label)
            .join(" ")}
        </span>
        <div
          className={`entry-list__logo ${
            filters.playerTypeCode.value === "Q" ||
            location.pathname.indexOf("paralympic") >= 0
              ? "paralympic"
              : ""
          }`}
        ></div>
      </div>
      <div className="entry-list__filters">
        {Object.keys(filtersList).map((field: string) => (
          <Dropdown
            options={filtersList[field]}
            value={filters[field]}
            onChange={selected => {
              setFilters(prev => ({
                ...prev,
                [field]: selected
              }));
            }}
            key={field}
          />
        ))}
        <a className="btn--print btn" onClick={() => window.print()}>
          Print
        </a>
      </div>
      {!isEmpty && !loading ? (
        <div className="entry-list__row">
          {list.map(({ nationCode, nationName, players }, sectionKey) => (
            <div className="entry-list__col" key={sectionKey}>
              {players.length ? (
                <>
                  <h3>
                    <div className={`itf-flags itf-flags--${nationCode}`}></div>
                    <span>{omitNation(nationName)}</span>
                  </h3>
                  <div className="entry-list__players">
                    <b>Players</b>
                    {players.map((group, groupKey: number) => (
                      <div
                        key={`section-${sectionKey}:group-${groupKey}`}
                        className="entry-list__players--group"
                      >
                        {group.map(
                          (
                            { familyName, profileLink, givenName, entryStatus },
                            playerKey: number
                          ) => (
                            <span
                              key={`section-${sectionKey}:group-${groupKey}:player-${playerKey}`}
                            >
                              {playerKey !== 0 && "/"}
                              <a href={`${profileLink}`}>
                                {`${givenName} `}&nbsp;
                                <span>{`${familyName.toUpperCase()}`}</span>
                                &nbsp;
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: entryStatus
                                  }}
                                />
                              </a>
                            </span>
                          )
                        )}
                      </div>
                    ))}
                  </div>
                </>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <div className="entry-list__empty">
          <p>Data not available</p>
        </div>
      )}
    </div>
  );
};

export default EntryList;
